module.exports = __webpack_public_path__ + "img/payBannerRed.b355f757.jpg";